import React, { useState } from "react";
import { Box, IconButton, Dialog, DialogContent, Button } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CloseIcon from "@mui/icons-material/Close";
import TranscriptionInstructions from "../../pages/TranscriptionInstructions/TranscriptionInstructions";
import { transform } from "framer-motion";

const FloatingInstructions = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="contained"
        onClick={() => setOpen(!open)}
        sx={{
          position: "fixed",
          top: "35%",
          right: 20,
          transform: "translateY(-50%)",
          zIndex: 1500,
          backgroundColor: "#ffd700",
          color: "#000",
          minWidth: "auto",
          padding: "4px 10px",
          fontSize: "12px",
          borderRadius: "20px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          "&:hover": { backgroundColor: "#e6c200" },
        }}
        startIcon={
          <HelpOutlineIcon
            sx={{ fontSize: 16, color: "#000", marginRight: "4px" }}
          />
        }
      >
        Instructions
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent>
          <TranscriptionInstructions />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FloatingInstructions;
